import React from "react";
import { Element } from "react-scroll";
import { Link } from "react-scroll";
import { OurStory, SecondComing, Editorial, Renaissance } from "./about-us/contents";

let duration = 1000;
export function AboutUsPage() {
  const titles = [
    {
      id: "our_story",
      title: "Our Story",
      content: <OurStory />,
    },
    {
      id: "second_coming",
      title: "The Second Coming",
      content: <SecondComing />,
    },

    {
      id: "renaissance",
      title: "The Churn Of Renaissance",
      content: <Renaissance />,
    },
    {
      id: "editorial_outlook",
      title: "Our Editorial Outlook",
      content: <Editorial />,
    },
  ];

  return (
    <>
      <div>
        <div className="relative py-3">
          <img src="https://swarajya.gumlet.io/assets/About%20us.webp?w=1080" alt="My Image" />
        </div>

        {/* <div className="navigation dark:bg-gray-800">
          {titles.map((title) => (
            <Link
              activeClass="active"
              to={title.id}
              spy
              smooth
              duration={duration}
              offset={-50}
              href={`#${title.id}`}
              key={title.id}
            >
              {title.title}
            </Link>
          ))}
        </div> */}
        <div className="section_wrapper flex flex-col">
          {titles.map((title) => (
            <Element className="section" name={title.id} key={title.id}>
              {title.content}
            </Element>
          ))}
        </div>
      </div>
    </>
  );
}
